const hasOwn = Object.prototype.hasOwnProperty;
const propertyIsEnumerable = Object.prototype.propertyIsEnumerable;
const getEnumerableKeys = (value) => [
    ...Object.keys(value),
    ...Object.getOwnPropertySymbols(value).filter((key) => propertyIsEnumerable.call(value, key)),
];
const isPlainComparableObject = (value) => {
    const prototype = Object.getPrototypeOf(value);
    return prototype === Object.prototype || prototype === null;
};
const hasSeenPair = (first, second, seen) => {
    const matches = seen.get(first);
    if (matches === null || matches === void 0 ? void 0 : matches.has(second))
        return true;
    if (matches) {
        matches.add(second);
    }
    else {
        seen.set(first, new WeakSet([second]));
    }
    return false;
};
const areValuesEqual = (first, second, seen) => {
    if (first === second)
        return true;
    if (typeof first === 'number' &&
        typeof second === 'number' &&
        Number.isNaN(first) &&
        Number.isNaN(second)) {
        return true;
    }
    if (first === null ||
        second === null ||
        typeof first !== 'object' ||
        typeof second !== 'object') {
        return false;
    }
    if (first instanceof Date || second instanceof Date) {
        if (!(first instanceof Date) || !(second instanceof Date))
            return false;
        const firstTime = first.getTime();
        const secondTime = second.getTime();
        return (firstTime === secondTime ||
            (Number.isNaN(firstTime) && Number.isNaN(secondTime)));
    }
    if (Array.isArray(first) || Array.isArray(second)) {
        if (!Array.isArray(first) || !Array.isArray(second))
            return false;
        if (first.length !== second.length)
            return false;
        if (hasSeenPair(first, second, seen))
            return true;
        return first.every((value, index) => areValuesEqual(value, second[index], seen));
    }
    if (!isPlainComparableObject(first) || !isPlainComparableObject(second)) {
        return false;
    }
    if (hasSeenPair(first, second, seen))
        return true;
    const firstKeys = getEnumerableKeys(first);
    const secondKeys = getEnumerableKeys(second);
    if (firstKeys.length !== secondKeys.length)
        return false;
    const firstRecord = first;
    const secondRecord = second;
    return firstKeys.every((key) => hasOwn.call(secondRecord, key) &&
        areValuesEqual(firstRecord[key], secondRecord[key], seen));
};
export const areListDataSourcesEqual = (first, second) => areValuesEqual(first, second, new WeakMap());
